// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fixed-table-item{background:#fff;max-width:200px!important;position:absolute;left:0;padding-left:20px!important}", ""]);
// Exports
module.exports = exports;
